module.exports = {
  single: {
    key: 'single',
    label: 'Single',
  },
  rule: {
    key: 'rule',
    label: 'Rule',
  },
};